export const eventStatusName = (status) => {
  if (status === 'GOING') {
    return 'Going';
  } else if (status === 'INTERESTED') {
    return 'Interested';
  } else if (status === 'NOT_GOING') {
    return 'Not Going';
  } else if (status === 'REQUESTED') {
    return 'Requested';
  }

  return null;
};
